import { render } from "./LandingEng.vue?vue&type=template&id=0fafd3b5&scoped=true&lang=html"
import script from "./LandingEng.vue?vue&type=script&lang=js"
export * from "./LandingEng.vue?vue&type=script&lang=js"

import "./LandingEng.vue?vue&type=style&index=0&id=0fafd3b5&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-0fafd3b5"

export default script